// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, doc, setDoc, getDoc } from "firebase/firestore"; // ✅ Import `getDoc` here
import { getAnalytics } from 'firebase/analytics';
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';

// ✅ Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCBO5rIjsn4pYGTNYOAqSf3p_J0-AWFFvM",
  authDomain: "flourishtalents1.firebaseapp.com",
  projectId: "flourishtalents1",
  storageBucket: "flourishtalents1.appspot.com",
  messagingSenderId: "849498638792",
  appId: "1:849498638792:web:7bb743fa19ccc5a02358fd",
  measurementId: "G-YCH32G4072"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Authentication
const auth = getAuth(app);

// ✅ Firestore instance
const db = getFirestore(app);

// ✅ Analytics (optional for now)
const analytics = getAnalytics(app);

// ✅ Helper function to add form data reusable for all collections to add form data with a custom document ID
const addFormData = async (data, collectionName, documentId) => {
  try {
    // Use `setDoc` to create a document with a custom ID
    const docRef = doc(db, collectionName, documentId);
    await setDoc(docRef, data);
    console.log("Document written with ID: ", docRef.id);
  } catch (error) {
    console.error("Error adding document: ", error);
    throw error;
  }
};

// ✅ Helper function to check if a username exists in the Firestore collection
const checkUsernameExists = async (username) => {
  try {
    const docRef = doc(db, "joyousApplications", username); // Assuming "joyousApplications" is the collection where data is stored
    const docSnap = await getDoc(docRef);

    // Returns true if the document exists, false if it doesn't
    return docSnap.exists();
  } catch (error) {
    console.error("Error checking username existence: ", error);
    throw error;
  }
};

// ✅ Export what you need
export { db, addFormData, checkUsernameExists };

export {
  auth,
  analytics,
  collection,  
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword
};